export default [
  {
    path: "cockpitTarget",
    name: "cockpitTarget",
    meta: {
      title: "目标管理"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitTarget/index.vue")
  },
  {
    path: "cockpitPerformanceReview",
    name: "cockpitPerformanceReview",
    meta: {
      title: "业绩复盘"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitPerformanceReview/index.vue")
  },
  {
    path: "setTarget",
    name: "setTarget",
    meta: {
      title: "设定目标"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitTarget/setTarget.vue")
  }
];
